import subject from "../topics/Topicts";

const subjects = [
  {
    id: 2,
    subject: 'Physics',
    name: 'Physics',
    icon: '⚛',
    color: '#2ecc71',
  },
  {
    id: 3,
    subject: 'Chemistry',
    name: 'Chemistry',
    icon: '⚗',
    color: '#9b59b6',
  },
  {
    id: 1,
    subject: 'Mathematics',
    name: 'Mathematics',
    icon: '∑',
    color: '#3498db',
  }
];

export default subjects;